/**
 * @generated SignedSource<<c6cd0b5fd17c8a07a00ed7194c554161>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentLinkCompleted_charge$data = {
  readonly company: {
    readonly nameFriendly: string | null | undefined;
    readonly taxID: {
      readonly taxID: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly discount: number | null | undefined;
  readonly id: string;
  readonly identifier: string | null | undefined;
  readonly redirectUrl: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentInstallmentPlan_charge" | "PaymentLinkAdditionalInfo_charge" | "PaymentLinkCompletedPaymentMethods_charge" | "PaymentLinkCompletedPixCreditCard_charge" | "PaymentLinkCompletedQrCodeValue_charge" | "PaymentLinkCompletedRedirect_charge" | "PaymentLinkCompletedRewards_charge" | "PaymentLinkCompletedTransaction_charge" | "PaymentLinkTransactionDetails_charge">;
  readonly " $fragmentType": "PaymentLinkCompleted_charge";
};
export type PaymentLinkCompleted_charge$key = {
  readonly " $data"?: PaymentLinkCompleted_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkCompleted_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentLinkCompleted_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "discount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identifier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "redirectUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameFriendly",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TaxID",
          "kind": "LinkedField",
          "name": "taxID",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "taxID",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkCompletedQrCodeValue_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentInstallmentPlan_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkCompletedTransaction_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkAdditionalInfo_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkCompletedRewards_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkTransactionDetails_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkCompletedPixCreditCard_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkCompletedPaymentMethods_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkCompletedRedirect_charge"
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "1cb554c6ea4ec8f41240c0dbea995790";

export default node;
